(function ($, Drupal, drupalSettings) {
  var windowWidth = function(){
    return (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth);
  }
  Drupal.behaviors.treston_base_table = {
    attach: function(context, settings) {
      // Table list functions
      
    }
  }
})(jQuery, Drupal, drupalSettings);